import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import StatsCard from "./components/StatsCard";
import "../../../src/assets/css/dashboard.css";

export default function App() {
  return (
    <div className="dashboard">
      <Sidebar >
        <Header />
        <div className="stats-grid">
          <StatsCard title="Total Blogs" value="8" />
        </div>
      </Sidebar>
    </div>
  );
}